// src/lib/upload.js
// Turn a picked file into a public R2 URL the FAL image tools can read.
// file → base64 → POST /images/upload-temp → { url }

import { images } from "../api";

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(",")[1]); // strip "data:...;base64,"
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export async function uploadToTempUrl(file) {
  const b64 = await fileToBase64(file);
  const res = await images.uploadTemp(b64);
  if (!res?.url) throw new Error("Upload failed");
  return res.url;
}
